import React from 'react';
import { Modal} from 'react-bootstrap'; 
import QrReader from 'react-qr-reader';
import { FormattedMessage } from 'react-intl'; 
import { formatMessage } from '../../../translations/connectedIntlProvider';
import { toast } from 'react-toastify';
import { resetGetSensorByIdState } from '../../../core/actions/sensors.action';
import { useDispatch } from 'react-redux';
 
interface Props {
    modalClosed: () => void;
    QrCodeSubmitHandler: (result:string) => void;
}
const QRCodeScanner: React.FC<Props>= (props) => {  
  const dispatch = useDispatch();
  const handleErrorWebCam = (error:any) => {
    toast.error(formatMessage(error));
    props.modalClosed();
  }

  const handleScanWebCam = (result: string | null) => {
    if (result){
        props.modalClosed();
        props.QrCodeSubmitHandler(result);
    }
   }

  const modalClosed = () => {
    dispatch(resetGetSensorByIdState());
    props.modalClosed();
  }

  return (
    <Modal show={true} centered onHide={modalClosed } dialogClassName="QRCode-scanner-popup">
    <Modal.Header closeButton>
        <Modal.Title><FormattedMessage id='QR_Code_Scanner' /></Modal.Title>
    </Modal.Header>
    <div>         
        <QrReader
        delay={5}
        style={{width: '100%'}}
        onError={(handleErrorWebCam)}
        onScan={handleScanWebCam}
        />
    </div>
</Modal>
    

  );
}
export default QRCodeScanner;
